// Import and init our Progress bar, which appears in the sidebar of the Module pages
import { ModuleProgress } from '../utils/moduleProgress';
ModuleProgress.init();